import { property, State } from '@common/lit/store/index.js';
import type { Purpose } from '@common/types/model.d.js';
import { DisplayMode } from '@src/config/index.js';

export class ComponentStateStore extends State {
  [key: string | symbol]: unknown;
  @property({ value: false }) disabled!: boolean;
  @property({ value: DisplayMode.view }) displayMode!: DisplayMode;
  @property({ value: undefined }) activePurpose!: Purpose;
}

export const store = new ComponentStateStore();
